// extracted by mini-css-extract-plugin
export default {"wrapper":"AddCommentNewsField_wrapper__DbN6F","textarea":"AddCommentNewsField_textarea__jrlKi","error":"AddCommentNewsField_error__ZMFfI"};